import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Error from '@/pages/Error';
import Account from '@/pages/Account';
import SignIn from '@/pages/SignIn';
import SSOCallback from '@/pages/SSOCallback';
import NotFound from '@/pages/NotFound';
import Thread from '@/pages/Thread';
import RouteGuard from '../RouteGuard';
import { Role } from '@/models/user';
import RootLayout from '@/layouts/RootLayout';
import AppLayout from '@/layouts/AppLayout';
import AppHome from '@/pages/AppHome';
import UsersManagement from '@/pages/UsersManagement';
import Library from '@/pages/Library';
import { SessionProvider } from '@/context/Session/SessionProvider';
import Search from '@/pages/Search';
import OrgsManagement from '@/pages/OrgsManagement';
import Confirmation from '@/pages/Confirmation';
const BrowserRoutes = () => {
  return (
    <BrowserRouter>
      <SessionProvider>
        <Routes>
          <Route element={<RootLayout />} errorElement={<Error />}>
            <Route path="sign-in" element={<SignIn />} />
            <Route path="auth/sso/callback" element={<SSOCallback />} />
            <Route path="not-found" element={<NotFound />} />
            <Route element={<RouteGuard />}>
              <Route path="confirmation" element={<Confirmation />} />
              <Route element={<AppLayout />}>
                <Route index element={<AppHome />} />
                <Route path="thread" element={<Thread />}>
                  <Route path=":id" />
                </Route>
                <Route path="library" element={<Library />}>
                  <Route path=":id" element={<Library />} />
                </Route>
                <Route path="search" element={<Search />} />
                <Route path="account" element={<Account />}>
                  <Route path="edit" />
                </Route>
                <Route
                  element={
                    <RouteGuard
                      allowedRoles={[Role.ORG_USER_ADMIN, Role.SUPER_ORG_ADMIN]}
                    />
                  }
                >
                  <Route
                    path="users-management"
                    element={<UsersManagement />}
                  />
                </Route>
                <Route
                  element={<RouteGuard allowedRoles={[Role.SUPER_ORG_ADMIN]} />}
                >
                  <Route path="orgs-management" element={<OrgsManagement />} />
                </Route>
              </Route>
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </SessionProvider>
    </BrowserRouter>
  );
};
export default BrowserRoutes;
